import React, { FC, useState } from 'react';
import { addTransformToCloudinaryUrl } from '@z-components/utils/url';

interface Props {
  url: string;
  width?: number;
  isLazy?: boolean;
  isAsync?: boolean;
  className?: string;
  imageAlt?: string;
}

const CloudinaryImage: FC<Props> = ({ url, width, isLazy, isAsync, className, imageAlt }) => {
  const [altUrl, setAltUrl] = useState(addTransformToCloudinaryUrl(url, { width }));
  return (
    <picture>
      <source
        className={className}
        srcSet={altUrl}
        type="image/avif"
        onError={() => setAltUrl(url)}
      />
      <source
        className={className}
        srcSet={altUrl}
        type="image/webp"
        onError={() => setAltUrl(url)}
      />
      <img
        className={className}
        src={altUrl}
        loading={isLazy ? 'lazy' : 'eager'}
        decoding={isAsync ? 'async' : 'auto'}
        onError={() => setAltUrl(url)}
        alt={imageAlt}
      />
    </picture>
  );
};

export default CloudinaryImage;
